<template>
  <SectionWrapper sectionId="knowledge">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <div v-if="isMobile().phone" class="knowledge_container">
          <hooper :settings="hooperSettings">
            <slide v-for="(webinar, index) in webinarList" :key="index">
              <NewsCard
                class="knowledge_item"
                :imgSrc="webinar['media:thumbnail']"
                :title="webinar.title"
                :publishIsoDate="webinar.isoDate"
                :link="webinar.link" />
            </slide>
            <HooperNavigation slot="hooper-addons"></HooperNavigation>
            <HooperPagination slot="hooper-addons"></HooperPagination>
          </hooper>
        </div>
        <div v-else class="knowledge_container">
          <NewsCard v-for="(webinar, index) in webinarList" :key="index"
                         class="knowledge_item"
                         :imgSrc="webinar['media:thumbnail']"
                         :title="webinar.title"
                         :publishIsoDate="webinar.isoDate"
                         :link="webinar.link" />
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
// import WebinarCard from '../atoms/WebinarCard'
import NewsCard from '../atoms/NewsCard'
import isMobile from 'ismobilejs'
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'
import { News as NewsFunction } from '../../functions/news'

export default {
  name: 'knowledge',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    NewsCard,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/knowledge_txt.svg'),
        text: 'knowledge',
        leading: 'build service を深く知る',
        description: ''
      },
      isMobile,
      webinarList: [],
      hooperSettings: {
        autoPlay: true,
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        playSpeed: 10000
      }
    }
  },
  async mounted () {
    const webinars = await NewsFunction.getWebinar()
    this.webinarList = webinars.sort((a, b) => {
      if (a.isoDate === b.isoDate) return 0
      return a.isoDate > b.isoDate ? -1 : 1
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/mixins';
@import 'hooper/dist/hooper.css';

.knowledge {
  &_container {
    display: flex;
    @include bpOnlySp() {
      flex-direction: column;
      align-items: center;
    }
  }
  &_item {
    margin: 0 auto;
    @include bpOnlyPc() {
      width: 280px;
      padding: 10px;
    }
    @include bpOnlySp() {
      align-items: center;
    }
  }
}

.hooper {
  height: 100%;
}
</style>
